import { FlechaDerecha } from '../componentes/Iconos.jsx';
import { Avatar } from '../componentes/Avatar.jsx';
import { ListaCargando } from '../componentes/Cargando.jsx';
import { Estado } from '../componentes/Estado.jsx';
import { POR_DEFECTO } from '../lib/vocabulario.js';

/**
 * @param {object} [vocabulario] cómo le dice este negocio a lo que se reserva.
 *   Sin esto, un club le pregunta a sus clientes "con quién" quieren jugar.
 */
export function PasoProfesional({
  profesionales, cargando, error, elegido, onElegir, onReintentar,
  vocabulario = POR_DEFECTO
}) {
  if (cargando) return <ListaCargando filas={2} />;

  if (error) {
    return (
      <Estado icono="sinSenal" titulo={`No pudimos cargar ${vocabulario.familia === 'cancha' ? 'las canchas' : 'el equipo'}`} accion={onReintentar} etiquetaAccion="Probar de nuevo">
        <p>{error}</p>
      </Estado>
    );
  }

  if (profesionales.length === 0) {
    return (
      <Estado icono="calendario" titulo={vocabulario.familia === 'cancha' ? 'No hay canchas disponibles para ese turno' : 'No hay nadie disponible para ese servicio'}>
        <p>Probá con otro servicio o escribile al negocio.</p>
      </Estado>
    );
  }

  return (
    <div className="lista">
      {profesionales.map((profesional) => (
        <button
          key={profesional.id}
          type="button"
          className="opcion"
          aria-pressed={elegido?.id === profesional.id}
          onClick={() => onElegir(profesional)}
        >
          <Avatar nombre={profesional.nombre} color={profesional.color} tamano={40} />
          <span className="opcion-cuerpo">
            <span className="opcion-nombre">{profesional.nombre}</span>
          </span>
          <FlechaDerecha className="opcion-flecha" />
        </button>
      ))}
    </div>
  );
}
